import { useEffect } from 'react';
import { useReactAudioContext } from '@tmsw/powerups.audio.provider';
import { usePauseConditions } from '../usePauseConditions';

export function useAudioPlayerEffects() {
  const { pausePlayers, unpausePlayers, players } = useReactAudioContext();
  const externalPauseTriggered = usePauseConditions()();

  useEffect(() => {
    try {
      console.log('checkPauseConditions effect hook', externalPauseTriggered);
      if (externalPauseTriggered) {
        console.log('Pausing players');
        pausePlayers();
      } else {
        console.log('Un-Pausing players');
        unpausePlayers();
        console.log('players', players);
      }
    } catch (e: any) {
      console.log(e);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [externalPauseTriggered]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !externalPauseTriggered) {
        unpausePlayers();
      } else {
        pausePlayers();
      }
    };
    // handleVisibilityChange();
    window.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [externalPauseTriggered]);
}
